export default "__VITE_ASSET__fb2cdc76__"